module.exports = __webpack_public_path__ + "media/checkout/BoxConfirmation-Lifekive-0f2c4fd6.jpg";